import { IAccount } from "../../../common/accounts2";
import { empty } from "../../../common/functions";
import { KapRemontBalanceBlock } from "./KapRemontBalanceBlock";
import { KapRemontTotalByMonthBlock } from "./KapRemontTotalByMonthBlock";

interface IAccountKapRemontTotalBlock {
  account: IAccount;
}
//отрисовывает данные по капремонту текущего аккаунта
export const AccountKapRemontTotalBlock = ({
  account,
}: IAccountKapRemontTotalBlock) => {
  const syncAcc = account.syncAccounts; //капремонт текущего аккаунта
  if (empty(syncAcc)) return <></>;
  else
    return (
      <div className="payment">
        <KapRemontBalanceBlock syncAcc={syncAcc[0]} />
        <KapRemontTotalByMonthBlock syncAcc={syncAcc[0]} />
      </div>
    );
};
